import styled from 'styled-components';
import { LabelText, UppercaseLabelText } from './LabelText';
import { Flex4XS } from '@/components/Flex';
import Icon from '../Icon/Icon';
import React from 'react';

const Box = styled(Flex4XS)<{
    $size?: string;
}>`
    display: inline-flex;
    border-radius: ${({ theme }) => theme.extras.radius.sm};
    padding-left: ${({ theme }) => theme.spacing['3xs']};
    padding-right: ${({ theme }) => theme.spacing['3xs']};

    justify-content: space-between;
    align-items: center;
    white-space: nowrap;

    // padding-top: ${({ $size }) => $size === 'xs' ? '4px' : '1px'};
    // padding-bottom: ${({ $size }) => $size === 'xs' ? '4px' : '1px'};
    
    height: ${({ $size }) => $size === 'xs' ? '24px' : '18px'};

    color: ${({ theme }) => theme.colors.palette.white};
    background-color: ${({ theme }) => theme.colors.palette.grey_900};
`;

const StyledIcon = styled(Icon)`
    color: ${({ theme }) => theme.colors.palette.white};
`;

export type LabelProps = {
    uppercase?: boolean;
    children?: React.ReactNode;
    leftIcon?: string | React.ReactNode;
    rightIcon?: string | React.ReactNode;
    size?: 'xs' | '2xs';
    noChildrenWrap?: boolean;
}

const Label = ({
    uppercase = false,
    children,
    leftIcon,
    rightIcon,
    size = '2xs',
    noChildrenWrap = false,
    ...rest
}: LabelProps) => {
    const TextComponent = uppercase ? UppercaseLabelText : LabelText;

    return (
        <Box $size={size} {...rest}>
            {leftIcon && (typeof leftIcon === 'string' ? <StyledIcon size='sm' name={leftIcon} /> : leftIcon)}
            {noChildrenWrap ? children : <TextComponent>{children}</TextComponent>}
            {rightIcon && (typeof rightIcon === 'string' ? <StyledIcon size='sm' name={rightIcon} /> : rightIcon)}
        </Box>
    );
};

export default Label;
